import React, { useState } from 'react';
import './BybitCredentials.css';

const BybitCredentials = ({ onCredentialsSet }) => {
  const [credentials, setCredentials] = useState({
    demoApiKey: '',
    demoApiSecret: '',
    liveApiKey: '',
    liveApiSecret: ''
  });
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('demo');

  const handleInputChange = (field, value) => {
    setCredentials(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveCredentials = () => {
    // Save to localStorage for now (in production, use secure storage)
    localStorage.setItem('bybit_credentials', JSON.stringify(credentials));
    
    // Notify parent component
    if (onCredentialsSet) {
      onCredentialsSet(credentials);
    }
    
    alert('✅ Bybit credentials saved successfully!');
    setIsVisible(false);
  };

  const loadSavedCredentials = () => {
    const saved = localStorage.getItem('bybit_credentials');
    if (saved) {
      setCredentials(JSON.parse(saved));
    }
  };

  React.useEffect(() => {
    loadSavedCredentials();
  }, []);

  if (!isVisible) {
    return (
      <button 
        className="credentials-toggle-btn"
        onClick={() => setIsVisible(true)}
      >
        🔑 Setup Bybit Credentials
      </button>
    );
  }

  return (
    <div className="credentials-modal">
      <div className="credentials-content">
        <div className="credentials-header">
          <h3>🔑 Bybit API Credentials Setup</h3>
          <button 
            className="close-btn"
            onClick={() => setIsVisible(false)}
          >
            ✕
          </button>
        </div>

        <div className="credentials-tabs">
          <button 
            className={`tab-btn ${activeTab === 'demo' ? 'active' : ''}`}
            onClick={() => setActiveTab('demo')}
          >
            🧪 Demo Account
          </button>
          <button 
            className={`tab-btn ${activeTab === 'live' ? 'active' : ''}`}
            onClick={() => setActiveTab('live')}
          >
            💰 Live Account
          </button>
        </div>

        <div className="credentials-form">
          {activeTab === 'demo' ? (
            <div className="demo-credentials">
              <h4>Demo Account (Testnet)</h4>
              <p className="info-text">
                Use your Bybit testnet API credentials for safe testing
              </p>
              
              <div className="form-group">
                <label>Demo API Key:</label>
                <input 
                  type="password"
                  value={credentials.demoApiKey}
                  onChange={(e) => handleInputChange('demoApiKey', e.target.value)}
                  placeholder="Enter your demo API key"
                />
              </div>
              
              <div className="form-group">
                <label>Demo API Secret:</label>
                <input 
                  type="password"
                  value={credentials.demoApiSecret}
                  onChange={(e) => handleInputChange('demoApiSecret', e.target.value)}
                  placeholder="Enter your demo API secret"
                />
              </div>
            </div>
          ) : (
            <div className="live-credentials">
              <h4>Live Account (Mainnet)</h4>
              <p className="warning-text">
                ⚠️ Use with caution! This will execute real trades with real money!
              </p>
              
              <div className="form-group">
                <label>Live API Key:</label>
                <input 
                  type="password"
                  value={credentials.liveApiKey}
                  onChange={(e) => handleInputChange('liveApiKey', e.target.value)}
                  placeholder="Enter your live API key"
                />
              </div>
              
              <div className="form-group">
                <label>Live API Secret:</label>
                <input 
                  type="password"
                  value={credentials.liveApiSecret}
                  onChange={(e) => handleInputChange('liveApiSecret', e.target.value)}
                  placeholder="Enter your live API secret"
                />
              </div>
            </div>
          )}

          <div className="credentials-actions">
            <button 
              className="save-btn"
              onClick={handleSaveCredentials}
            >
              💾 Save Credentials
            </button>
            <button 
              className="cancel-btn"
              onClick={() => setIsVisible(false)}
            >
              Cancel
            </button>
          </div>
        </div>

        <div className="credentials-help">
          <h5>📋 How to get your Bybit API credentials:</h5>
          <ol>
            <li>Log in to your Bybit account</li>
            <li>Go to Account → API Management</li>
            <li>Create a new API key</li>
            <li>Set permissions: Read, Trade (for trading)</li>
            <li>Copy the API Key and Secret</li>
            <li>For demo: Use testnet.bybit.com</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default BybitCredentials;

